<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row class="bg-kiri" no-gutters>
          <v-col cols="2"></v-col>
          <v-col cols="10" class="pa-5" style="background-color: white">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-list-item class="px-0">
                      <v-list-item-avatar color="blue">
                        <v-icon dark>mdi-office-building-outline</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="body-1 mb-0">
                          <strong class="blue--text">
                            {{ $getDeepObj(detail, 'psp_diklat_sekolah.sekolah.nama') || '-' }}
                          </strong>
                        </div>
                        <div class="body-2">
                          <strong>NPSN:</strong>
                          {{ $getDeepObj(detail, 'psp_diklat_sekolah.sekolah.npsn') || '-' }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 px-1">
                        <div class="caption grey--text text-lighten-1">
                          Alamat Sekolah
                        </div>
                        <div class="body-2 mb-0">
                          {{ $getDeepObj(detail, 'psp_diklat_sekolah.sekolah.alamat') }}<br />
                          {{
                            [
                              $getDeepObj(detail, 'psp_diklat_sekolah.sekolah.m_kota.keterangan'),
                              $getDeepObj(detail, 'psp_diklat_sekolah.sekolah.m_propinsi.keterangan'),
                            ].join(' - ')
                          }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card v-if="Object.keys(form).length > 0" tile flat class="my-5">
      <v-card-text>
        <v-alert prominent text type="info">
          <h4 class="black--text">Instruksi Pengisian</h4>
          <span class="black--text body-2">
            Mohon mengisi data ajuan calon peserta pelatihan sebelum
            {{ $localDate($getDeepObj(detail, 'jadwal.wkt_selesai') || '') }}, sesuai dengan kriteria berikut:
          </span>
          <Instruksi v-if="!isDiklatSmk" />
          <InstruksiSmk v-else />
        </v-alert>
        <template v-for="(item, i) in schema">
          <h3 class="black--text" :key="`header-${i}`" v-if="item.header">Pilih {{ item.header }}</h3>
          <v-row :key="`body-${i}-${count}`" dense v-for="(count, idx) in item.jumlah">
            <v-col cols="12" md="6">
              <span class="body-2 px-0" style="height: 24px">
                Perwakilan
              </span>
              <div style="background-color: #F3F3F3; font-size: 16px" class="pa-2">
                <span v-if="item.name === 'kejuruan'"> {{ item.title }} {{ kompetensi.kompetensi }} </span>
                <span v-else> {{ item.title }} {{ item.jumlah > 1 ? count : '' }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <span class="px-0 body-2" style="height: 24px">
                Pilih {{ item.title }}{{ item.jumlah > 1 ? ` ${count}` : '' }} yang sesuai
              </span>
              <v-autocomplete
                v-model="form[item.name][idx]"
                :items="master[`${item.name}_${idx}`]"
                :label="`Pilih ${item.title} ${item.jumlah > 1 ? ` ${count}` : ''}`"
                :loading="loading[`${item.name}_${idx}`]"
                :search-input.sync="search[`${item.name}_${idx}`]"
                :placeholder="`Silakan ketik untuk mencari nama ${item.title}`"
                messages="."
                clearable
                hide-no-data
                single-line
                item-text="text"
                item-value="value"
                dense
                outlined
                @focus="onFocus(`${item.name}_${idx}`)"
              >
                <template v-slot:selection="data">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.text }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="grey--text text--darken-1">
                      {{ data.item.value }}
                    </v-list-item-subtitle>
                    <div class="d-flex flex-wrap">
                      <span class="mr-2" style="font-size: 12px">
                        <template v-if="data.item.is_registrasi">
                          <v-icon color="success" x-small>mdi-check-circle</v-icon>
                          Registrasi Akun SIMPKB: <span class="green--text">Sudah</span>
                        </template>
                        <template v-else>
                          <v-icon color="error" x-small>mdi-close-circle</v-icon>
                          Registrasi Akun SIMPKB: <span class="error--text">Belum</span>
                        </template>
                      </span>
                      <template v-if="item.name !== 'pengawas'">
                        <span class="mr-2" style="font-size: 12px">
                          <template v-if="data.item.aktif">
                            <v-icon color="success" x-small>mdi-check-circle</v-icon>
                            Dapodik: <span class="green--text">Aktif</span>
                          </template>
                          <template v-else>
                            <v-icon color="error" x-small>mdi-close-circle</v-icon>
                            Dapodik: <span class="error--text">Tidak Aktif</span>
                          </template>
                        </span>
                        <span class="mr-2" style="font-size: 12px">
                          <template v-if="data.item.satminkal">
                            <v-icon color="success" x-small>mdi-check-circle</v-icon>
                            Naungan: <span class="green--text">Satminkal</span>
                          </template>
                          <template v-else>
                            <v-icon color="error" x-small>mdi-close-circle</v-icon>
                            Naungan: <span class="error--text">Non Satminkal</span>
                          </template>
                        </span>
                      </template>
                    </div>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.text }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ data.item.value }}
                    </v-list-item-subtitle>
                    <div class="d-flex flex-wrap">
                      <span class="mr-2" style="font-size: 12px">
                        <template v-if="data.item.is_registrasi">
                          <v-icon color="success" x-small>mdi-check-circle</v-icon>
                          Registrasi Akun SIMPKB: <span class="green--text">Sudah</span>
                        </template>
                        <template v-else>
                          <v-icon color="error" x-small>mdi-close-circle</v-icon>
                          Registrasi Akun SIMPKB: <span class="error--text">Belum</span>
                        </template>
                      </span>
                      <template v-if="item.name !== 'pengawas'">
                        <span class="mr-2" style="font-size: 12px">
                          <template v-if="data.item.aktif">
                            <v-icon :color="data.item.disabled ? 'grey' : 'success'" x-small>mdi-check-circle</v-icon>
                            Dapodik: <span :class="data.item.disabled ? 'grey--text' : 'green--text'">Aktif</span>
                          </template>
                          <template v-else>
                            <v-icon :color="data.item.disabled ? 'grey' : 'error'" x-small>mdi-close-circle</v-icon>
                            Dapodik: <span :class="data.item.disabled ? 'grey--text' : 'error--text'">Tidak Aktif</span>
                          </template>
                        </span>
                        <span class="mr-2" style="font-size: 12px">
                          <template v-if="data.item.satminkal">
                            <v-icon :color="data.item.disabled ? 'grey' : 'success'" x-small>mdi-check-circle</v-icon>
                            Naungan: <span :class="data.item.disabled ? 'grey--text' : 'green--text'">Satminkal</span>
                          </template>
                          <template v-else>
                            <v-icon :color="data.item.disabled ? 'grey' : 'error'" x-small>mdi-close-circle</v-icon>
                            Naungan:
                            <span :class="data.item.disabled ? 'grey--text' : 'error--text'">Non Satminkal</span>
                          </template>
                        </span>
                        <span class="mr-2" style="font-size: 12px">
                          <template v-if="data.item.is_guru_bk">
                            <v-icon :color="data.item.disabled ? 'grey' : 'success'" x-small>mdi-check-circle</v-icon>
                            Status: <span :class="data.item.disabled ? 'grey--text' : 'green--text'">Guru BK</span>
                          </template>
                        </span>
                      </template>
                    </div>
                  </v-list-item-content>
                </template>
                <template v-slot:message>
                  <div v-if="isOpsional(item.name)" class="label--text mb-2 ml-n2 orange--text text--darken-3">
                    Jika di sekolah Anda masih terdapat guru lain, silakan Anda pilih dan jadikan guru tersebut menjadi
                    peserta cadangan
                  </div>
                  <span
                    v-else-if="item.name === 'bk' && !isDiklatSmk"
                    class="label--text mb-2 ml-n2 orange--text text--darken-3"
                  >
                    Diprioritaskan untuk guru yang mengampu mata pelajaran BK. Jika tidak ada, maka bisa ditugaskan guru
                    dan tenaga kependidikan yang lain
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Instruksi from './formulir/Instruksi.vue';
import InstruksiSmk from './formulir/InstruksiSmk.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: { Instruksi, InstruksiSmk },
  props: {
    pesertaPsp: {
      type: Object,
      default: () => {},
    },
    kandidatPsp: {
      type: Object,
      default: () => {},
    },
    config: Array,
    default: () => [],
    detail: {
      type: Object,
      default: () => {},
    },
    isDiklatSmk: {
      type: Boolean,
      default: false,
    },
    isP4tk: {
      type: Boolean,
      default: false,
    },
    kompetensi: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      loading: {},
      search: {},
      debounce: {},
      master: {},
      cache: {},
    };
  },

  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
    }),

    gelombang() {
      return Number(this.$getDeepObj(this.detail, 'psp_diklat_sekolah.gelombang'));
    },

    schema() {
      const indexBk = this.config.findIndex((item) => item.kelompok === 'BK');
      const indexUmum = this.config.findIndex((item) => item.kelompok === null);
      const indexKejuruan = this.config.findIndex((item) => +item.k_mapel_psp === 208);
      const indexKejuruanLain = this.config.findIndex((item) => +item.k_mapel_psp === 210);
      return [
        ...(this.isDiklatSmk
          ? [
              {
                header: 'Wakil Kepala Sekolah (Bid. Kurikulum)',
                title: 'Wakil Kepala Sekolah (Bid. Kurikulum)',
                name: 'wakasek',
                jumlah: 1,
              },
            ]
          : []),
        ...(!(!this.isDiklatSmk && this.gelombang === 2)
          ? [
              {
                header: 'Pengawas',
                title: 'Pengawas Sekolah',
                name: 'pengawas',
                jumlah: 1,
              },
            ]
          : []),
        ...(indexBk > -1
          ? [
              {
                header: 'Guru',
                title: 'Guru BK',
                name: 'bk',
                jumlah: this.config[indexBk]['maks_guru'],
              },
            ]
          : []),
        ...(indexKejuruan > -1
          ? [
              {
                title: 'Guru Program Keahlian Unggulan',
                name: 'kejuruan',
                jumlah: this.config[indexKejuruan]['maks_guru'],
              },
            ]
          : []),
        ...(indexKejuruanLain > -1
          ? [
              {
                title: 'Guru Program Keahlian Unggulan Lainnya',
                name: 'kejuruanLain',
                jumlah: this.config[indexKejuruanLain]['maks_guru'],
              },
            ]
          : []),
        {
          title: this.isDiklatSmk ? 'Guru Umum' : 'Guru',
          name: 'guru',
          jumlah: this.config[indexUmum]['maks_guru'],
        },
        {
          header: 'Guru Cadangan',
          title: this.isDiklatSmk ? 'Guru Cadangan (Program Keahlian / Umum)' : 'Guru Cadangan',
          name: 'cadangan',
          jumlah: 1,
        },
      ];
    },
  },
  async mounted() {
    const params = {
      page: 1,
      count: 999,
    };

    if (!this.isP4tk) {
      const attr = { endpoint: '/guru' };
      const resp = await Promise.all([
        this.fetch({ attr, params: Object.assign(params, { jenis: 1 }) }),
        this.fetch({ attr, params: Object.assign(params, { jenis: 2 }) }),
        this.fetch({ attr, params: Object.assign(params, { jenis: 3 }) }),
        ...(this.isDiklatSmk ? [this.fetchWakasek({ params: Object.assign(params) })] : []),
      ]);

      this.setKandidat(resp);
    }
  },
  methods: {
    ...mapActions('pkp', ['fetch', 'fetchWakasek']),

    setKandidat(resp) {
      let kandidatGuru = (resp && resp[0] && resp[0]['data']) || [];
      if (this.isP4tk) {
        kandidatGuru = this.kandidatPsp['guru_mapel'] || [];
      }

      let kandidatPengawas = (resp && resp[1] && resp[1]['data']) || [];
      if (this.isP4tk) {
        kandidatPengawas = this.kandidatPsp['pengawas'] || [];
      }

      let kandidatBk = (resp && resp[2] && resp[2]['data']) || [];
      if (this.isP4tk) {
        kandidatBk = this.kandidatPsp['guru_bk'] || [];
      }

      let kandidatWakasek = (resp && resp[3]) || [];
      if (this.isP4tk) {
        kandidatWakasek = this.kandidatPsp['wakasek'] || [];
      }

      this.cache['guru'] = kandidatGuru.map((item) => {
        return {
          text: item.nama,
          value: item.id || item.ptk_id,
          aktif: this.$getDeepObj(item, 'ptk_sekolah.k_keluar') ? false : true,
          is_registrasi: this.$getDeepObj(item, 'paspor_id') ? true : false,
          satminkal: Boolean(this.$getDeepObj(item, 'ptk_sekolah.ptk_induk')),
        };
      });
      this.cache['pengawas'] = kandidatPengawas.map((item) => {
        return {
          text: item.nama,
          value: item.id || item.ptk_id,
          aktif: this.$getDeepObj(item, 'ptk_sekolah.k_keluar') ? false : true,
          is_registrasi: this.$getDeepObj(item, 'paspor_id') ? true : false,
          satminkal: Boolean(this.$getDeepObj(item, 'ptk_sekolah.ptk_induk')),
        };
      });
      this.cache['bk'] = kandidatBk.map((item) => {
        return {
          text: item.nama,
          value: item.id || item.ptk_id,
          aktif: this.$getDeepObj(item, 'ptk_sekolah.k_keluar') ? false : true,
          is_registrasi: this.$getDeepObj(item, 'paspor_id') ? true : false,
          is_guru_bk: [5].includes(+item.k_jenis_ptk),
          satminkal: Boolean(this.$getDeepObj(item, 'ptk_sekolah.ptk_induk')),
        };
      });
      this.cache['wakasek'] = kandidatWakasek.map((item) => {
        return {
          text: item.nama,
          value: item.id || item.ptk_id,
          aktif: this.$getDeepObj(item, 'ptk_sekolah.k_keluar') ? false : true,
          is_registrasi: this.$getDeepObj(item, 'paspor_id') ? true : false,
          satminkal: Boolean(this.$getDeepObj(item, 'ptk_sekolah.ptk_induk')),
        };
      });

      this.initForm();
    },

    initForm() {
      let initPeserta = {};
      for (const item of this.schema) {
        initPeserta[item.name] = [];
        for (let i = 0; i < item.jumlah; i++) {
          this.$set(
            this.master,
            `${item.name}_${i}`,
            item.name === 'wakasek'
              ? this.cache['wakasek']
              : item.name === 'pengawas'
              ? this.cache['pengawas']
              : ['bk', 'bkCadang'].includes(item.name)
              ? this.cache['bk']
              : this.cache['guru']
          );
          this.$set(this.loading, `${item.name}_${i}`, false);
          this.$set(this.search, `${item.name}_${i}`, null);
          this.$set(this.debounce, `${item.name}_${i}`, null);
          initPeserta[item.name].push(this.$getDeepObj(this.pesertaPsp[item.name][i], `ptk_id`) || '');
        }
      }
      this.$set(this, 'form', initPeserta);
    },

    isOpsional(column) {
      if (!this.isDiklatSmk) {
        return ['cadangan'].includes(column);
      } else {
        return ['bkCadang'].includes(column);
      }
    },

    onSearch(keyword, tipe) {
      const jenis = (tipe && tipe.split('_')) || ['guru'];

      const hasList = this.master[tipe].filter(
        (item) => (item.text || '').toLowerCase().indexOf(keyword.toLowerCase()) > -1
      );
      if (hasList.length > 0) return;

      clearTimeout(this.debounce && this.debounce[tipe]);
      this.debounce[tipe] = setTimeout(async () => {
        this.loading[tipe] = true;
        const attr = { endpoint: '/guru' };
        const params = {
          page: 1,
          limit: 10,
          jenis: jenis[0] === 'pengawas' ? 2 : ['bk', 'bkCadang'].includes(jenis[0]) ? 3 : 1,
          keyword: keyword || '',
        };

        const resp = await this[jenis[0] === 'wakasek' ? 'fetchWakasek' : 'fetch']({ attr, params });
        const data = jenis[0] === 'wakasek' ? resp || [] : resp.data || [];

        this.loading[tipe] = false;
        this.master[tipe] = data.map((item) => {
          return {
            text: item.nama,
            value: item.id || item.ptk_id,
            aktif: !(this.$getDeepObj(item, 'ptk_sekolah.k_keluar') || this.$getDeepObj(item, 'ptk_sekolah.k_keluar')),
            is_registrasi: !!this.$getDeepObj(item, 'paspor_id'),
            satminkal: Boolean(
              this.$getDeepObj(item, 'ptk_sekolah.ptk_induk') || this.$getDeepObj(item, 'ptk_sekolah.ptk_induk')
            ),
          };
        });
      }, 600);
    },

    getValue() {
      return this.form;
    },

    onFocus(masterName) {
      const tipe = masterName.split('_');
      const value = this.form[tipe[0]][+tipe[1]] || '';
      const form = [].concat(...(Object.values(this.form) || [])).filter((n) => n || (n && n !== value));

      const mapMaster = this.master[masterName].map((item) => {
        return Object.assign({}, item, {
          disabled: form.includes(item.value),
        });
      });

      this.master[masterName] = mapMaster;
    },
  },
  watch: {
    search: {
      handler(value) {
        let keyWithValue = '';
        for (let key in value) {
          if (value[key]) {
            keyWithValue = key;
          }
        }
        if (value[keyWithValue]) this.onSearch(value[keyWithValue], keyWithValue);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
>>> .v-list-item__content {
  flex: auto !important;
}

.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
